import React, { useEffect } from 'react';
import { useServerData } from '@xingternal/hops';
import { useIntl } from 'react-intl';
import { useTrackPage } from '@/hooks/useTrackPage';
import { useMostVisitedCompanies } from '@/hooks/useMostVisitedCompanies';
import { usePagination } from '@/hooks/usePagination';
import { CompanyLoggedout } from '@/components/CompanyLoggedout';
import { pagesTrackingName } from '@/utils/tracking';
import { Company } from '@/types/graphql-types';
import { LOGGED_IN_CARDS_PER_PAGE, LOGGED_OUT_CARDS_PER_PAGE } from '@/config';
import { scrollToTop } from '@/utils';
import styles from './MostVisitedCompanies.css';

const MostVisitedCompanies: React.FC = () => {
  const intl = useIntl();
  const { changePage, activePage } = usePagination();
  const { authenticated } = useServerData();
  useEffect(() => scrollToTop(), []);

  const limit = authenticated
    ? LOGGED_IN_CARDS_PER_PAGE
    : LOGGED_OUT_CARDS_PER_PAGE;

  const { data, loading, error } = useMostVisitedCompanies({
    limit,
    offset: limit * (activePage - 1),
  });

  useTrackPage({ pageName: pagesTrackingName.mostVisited });

  const { collection, total } = data?.mostVisitedCompanies ?? {};

  return (
    <CompanyLoggedout
      companies={collection?.map((item) => item?.company as Company)}
      total={total}
      headerText={intl.formatMessage({ id: 'CP_100_MOST_CLICKED_COMPANIES' })}
      authenticated={authenticated}
      limit={limit}
      activePage={activePage}
      changePage={changePage}
      loading={loading}
      error={error}
      styles={styles}
    />
  );
};

export { MostVisitedCompanies };
